import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacab() {



const cardData = {
  keyword: " Pune to Lonavala Cab ",

"headingDescription": "Srs Cab Service Offers a Pune to Lonavala Cab service comfortable, safe, and reliable travel option for passengers planning a trip to the beautiful hill station of Lonavala. Whether it’s a weekend getaway, family outing, or corporate trip, our professional drivers and well-maintained vehicles ensure a smooth journey through scenic ghats. We provide one-way rides, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Lonavala Cab, enjoy easy online booking, 24/7 customer support, and a relaxing ride through the Western Ghats.",
"topPlaces": [
  {
    "title": "Tiger Point",
    "description": "Tiger Point is one of the most popular viewpoints in Lonavala, offering breathtaking views of valleys and hills. Travelers booking Pune to Lonavala Cab often stop here to enjoy cool breeze and scenic landscapes."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a famous monsoon attraction known for its flowing water and lively atmosphere. Visitors using Pune to Lonavala Cab enjoy relaxing and spending time in the refreshing surroundings."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point is known for its stunning panoramic views and misty weather. Travelers using Pune to Lonavala Cab frequently visit this spot for photography and peaceful nature experiences."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves are ancient Buddhist rock-cut caves with impressive architecture. Visitors traveling via Pune to Lonavala Cab explore this historical site to witness intricate carvings and heritage."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves are a group of ancient caves known for their historical importance and beautiful surroundings. Travelers often include this spot during their Pune to Lonavala Cab journey."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a popular trekking destination offering scenic views of the Sahyadri mountains. Adventure lovers using Pune to Lonavala Cab often plan a visit here for trekking and exploration."
  },
  {
    "title": "Lonavala Lake",
    "description": "Lonavala Lake is a peaceful spot surrounded by greenery, especially beautiful during monsoon. Travelers booking Pune to Lonavala Cab can relax here and enjoy the calm environment."
  },
  {
    "title": "Khandala Ghat",
    "description": "Khandala Ghat is known for its winding roads and scenic beauty. Passengers traveling via Pune to Lonavala Cab enjoy the drive through this picturesque route."
  },
  {
    "title": "Celebrity Wax Museum",
    "description": "Celebrity Wax Museum features lifelike statues of famous personalities. Visitors using Pune to Lonavala Cab can enjoy a fun and entertaining experience here with family and friends."
  },
  {
    "title": "Duke’s Nose",
    "description": "Duke’s Nose is a cliff known for trekking and stunning valley views. Travelers booking Pune to Lonavala Cab often visit this spot for adventure activities and scenic beauty."
  }
],



services: [
{
name: "Pune to Lonavala Cab Booking",
description: "Pune to Lonavala cab booking offers quick and easy reservations for hill station trips. Customers can book cabs online for one-way or round journeys. Comfortable vehicles ensure smooth travel via expressway. Professional drivers ensure safe and timely rides. Transparent pricing ensures affordability. Book your Pune to Lonavala cab for a hassle-free trip."
},
{
name: "Taxi from Pune to Lonavala Karla Caves",
description: "Taxi from Pune to Lonavala Karla Caves provides convenient travel for sightseeing trips. Customers can visit historic caves comfortably with private cabs. Professional drivers ensure safe travel on hilly routes. Ideal for tourists and family outings. Flexible booking options are available. Travel easily to Karla Caves from Pune with taxi services."
},
{
name: "Pune to Lonavala Car Hire",
description: "Pune to Lonavala car hire offers flexible vehicle options for short trips. Customers can choose sedan, SUV, or luxury cars as per needs. Professional drivers ensure smooth and safe journeys. Ideal for weekend getaways and family trips. Transparent pricing ensures fair fares. Hire cars from Pune to Lonavala for comfortable travel."
},
{
name: "Pune to Lonavala Cab Rental",
description: "Pune to Lonavala cab rental provides convenient travel solutions for hill station visits. Customers can book vehicles for one-day or multiple-day trips. Comfortable cars ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures affordability. Rent cabs for Pune to Lonavala travel easily."
},
{
name: "Pune to Lonavala Cab Price",
description: "Pune to Lonavala cab price service offers clear and transparent fare details. Customers can check pricing before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose cab services with clear pricing for Lonavala trips."
},
{
name: "Pune to Lonavala Taxi Fare",
description: "Pune to Lonavala taxi fare provides estimated travel costs for passengers. Customers can plan trips with clear pricing details. Affordable fares ensure cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Travel confidently with taxi services from Pune to Lonavala."
},
{
name: "Book Cab from Pune to Lonavala",
description: "Book cab from Pune to Lonavala service offers easy online reservations. Customers can book rides instantly for hill station trips. Professional drivers ensure safe and smooth journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Book your Pune to Lonavala cab with ease."
},
{
name: "Pune to Lonavala Travel by Taxi to Kune Falls",
description: "Pune to Lonavala taxi to Kune Falls offers scenic travel for nature lovers. Customers can visit waterfalls comfortably with private cabs. Professional drivers ensure safe hill driving. Ideal for weekend trips and photography tours. Flexible booking options are available. Travel easily to Kune Falls from Pune with cab services."
},
{
name: "Pune to Lonavala Cabs",
description: "Pune to Lonavala cabs provide reliable transportation for short-distance travel. Customers can choose from multiple vehicle options. Professional drivers ensure smooth and safe journeys. One-way and round trip options are available. Transparent pricing ensures affordability. Travel comfortably with Pune to Lonavala cab services."
},
{
name: "Pune to Lonavala Cab Tour Package",
description: "Pune to Lonavala cab tour package offers complete travel solutions for tourists. Customers can explore popular attractions with planned itineraries. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Choose tour packages for hassle-free Lonavala trips."
},
{
name: "Pune to Lonavala Taxi Fare",
description: "Pune to Lonavala taxi fare service provides clear pricing for travel planning. Customers can estimate costs before booking rides. Affordable fares ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel with transparent taxi fare services to Lonavala."
},
{
name: "Pune Airport to Lonavala Taxi Fare",
description: "Pune airport to Lonavala taxi fare offers reliable airport transfer pricing. Customers can book cabs directly from airport to Lonavala. Professional drivers ensure timely pickups. Comfortable vehicles ensure smooth travel. Transparent pricing ensures affordability. Travel easily from Pune Airport to Lonavala with taxi services."
},
{
name: "Book Cab From Pune to Lonavala",
description: "Book cab from Pune to Lonavala service provides quick and convenient reservations. Customers can book rides online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Book your cab easily for Pune to Lonavala trips."
},
{
name: "Cab Fare from Pune to Lonavala",
description: "Cab fare from Pune to Lonavala provides detailed pricing for travelers. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose cab services with transparent fare details."
},
{
name: "Cab Service From Pune to Lonavala",
description: "Cab service from Pune to Lonavala offers reliable transportation for tourists and commuters. Customers can book cabs for one-way or round trips. Professional drivers ensure safe and smooth journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Travel easily with Pune to Lonavala cab services."
},
{
name: "Hinjewadi to Lonavala Taxi Fare",
description: "Hinjewadi to Lonavala taxi fare service provides convenient pricing for IT hub travelers. Customers can book cabs directly from Hinjewadi to Lonavala. Affordable fares ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily from Hinjewadi to Lonavala with taxi services."
},
{
name: "Lonavala to Bhimashankar Taxi",
description: "Lonavala to Bhimashankar taxi offers comfortable travel to religious destinations. Customers can visit Bhimashankar temple with ease. Professional drivers ensure safe travel through ghat roads. Ideal for pilgrimage trips. Flexible booking options are available. Travel from Lonavala to Bhimashankar with reliable taxi services."
},
{
name: "Lonavala to Matheran Taxi Fare",
description: "Lonavala to Matheran taxi fare service provides convenient pricing for hill station travel. Customers can plan trips easily with clear fare details. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Affordable pricing ensures value for money. Travel from Lonavala to Matheran with taxi services."
},
{
name: "Lonavala to Pune Cab Service",
description: "Lonavala to Pune cab service offers reliable return travel options. Customers can book cabs for smooth journeys back to Pune. Professional drivers ensure safe and timely travel. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel easily from Lonavala to Pune with cab services."
},
{
name: "Lonavala to Pune Taxi",
description: "Lonavala to Pune taxi service provides convenient transportation for return trips. Customers can book taxis for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures fair fares. Choose Lonavala to Pune taxi services for hassle-free travel."
}
],

tableData: [
["Pune to Lonavala Cab Booking","Taxi from Pune to Lonavala Karla Caves"],
["Pune to Lonavala Car Hire","Pune to Lonavala Cab Rental"],
["Pune to Lonavala Cab Price","Pune to Lonavala Taxi Fare"],
["Book Cab from Pune to Lonavala","Pune to Lonavala Travel by Taxi to Kune Falls"],
["Pune to Lonavala Cabs","Pune to Lonavala Cab Tour Package"],
["Pune to Lonavala Taxi Fare","Pune Airport to Lonavala Taxi Fare"],
["Book Cab From Pune to Lonavala","Cab Fare from Pune to Lonavala"],
["Cab Service From Pune to Lonavala","Hinjewadi to Lonavala Taxi Fare"],
["Lonavala to Bhimashankar Taxi","Lonavala to Matheran Taxi Fare"],
["Lonavala to Pune Cab Service","Lonavala to Pune Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Lonavala Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides experienced drivers familiar with Pune to Lonavala routes, expressways, and ghat sections, ensuring a safe, smooth, and enjoyable journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Lonavala Cab Rates",
    WhyChoosedescription: "We offer budget-friendly Pune to Lonavala cab services with transparent pricing. Customers get clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service is available 24/7 for Pune to Lonavala cab bookings, perfect for weekend trips, late-night travel, or early morning departures."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "All our vehicles are clean, well-maintained, and air-conditioned, ensuring a relaxing travel experience from Pune to Lonavala."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Lonavala trips and sightseeing."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for couples, families, and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide easy pickup from homes, hotels, offices, and Pune Airport across all major locations including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Weekend Travel Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Lonavala cab bookings with punctual drivers, comfortable vehicles, and reliable service for short trips."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Lonavala cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Lonavala with experienced drivers." },
  { question: "How far is Lonavala from Pune?", answer: "The distance between Pune and Lonavala is approximately 65 km and the journey takes around 1.5 to 2 hours." },
  { question: "Is Pune to Lonavala cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for Pune to Lonavala travel." },
  { question: "Which vehicles are available for Lonavala trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Lonavala?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide Lonavala sightseeing?", answer: "Yes, we offer local sightseeing packages covering all major tourist points in Lonavala." },
  { question: "Are vehicles suitable for ghat roads?", answer: "Yes, all vehicles are well-maintained and suitable for ghat driving." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Lonavala cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar More",
    feedback:
      "Booked SRS Cab Service for Pune to Lonavala trip. Smooth ride and driver was very cooperative.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Desai",
    feedback:
      "Perfect cab service for weekend trip to Lonavala. Clean car and on-time pickup.",
    rating: 5
  }
];


































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Lonavala cab services including taxi bookings, car hire, and cab rentals. Visit Karla Caves, Kune Falls, Bhimashankar, Matheran, and other scenic spots. Book one-way trips, round trips, or cab tour packages. Enjoy safe, comfortable, and punctual rides with 24x7 online booking from Pune to Lonavala.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Lonavala Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Lonavala cabs with SRS Cab. Taxi service, car hire, cab rentals for one-way, round trips, or tour packages. Visit Karla Caves, Kune Falls, Bhimashankar, Matheran with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetolonavalacab;